import { Installment } from '../Student/StudentDetailView/types';

export interface SectionTimeSlot {
  id: number;
  timeSlot: {
    id: number;
    weekDay?: string;
    startTime: string;
    endTime: string;
  };
}

export interface Section {
  id: number;
  mipreuId: number;
  location?: {
    id: number;
    name: string;
  };
  classroom?: string;
  sectionTimeSlots?: SectionTimeSlot[];
}

export interface StudentProgram {
  id: number;
  programId: number;
  sectionId: number | null;
  section?: Section | null;
  program: {
    id: number;
    name: string;
    startDate: string | Date;
    endDate: string | Date;
    fee: number;
    subject: {
      id: number;
      name: string;
    };
  };
  feeDiscount: number;
  comment: string | null;
}

export interface StudentInfo {
  id: number;
  title: string;
  subtitle: string[] | string;
  text: string[] | string;
}

export interface ProgramCardType {
  studentProgram: StudentProgram;
  showPrices: boolean;
  onAssignSection?: (studentProgram: StudentProgram) => void;
  onEditProgram?: (studentProgram: StudentProgram) => void;
  onDeleteProgram?: (studentProgram: StudentProgram) => void;
}

export interface CardPriceType {
  title: string;
  originalPrice: number;
  discountType?: 'percentage' | 'flat';
  discountPrice: number;
  finalPrice: number;
}

export interface ContractComment {
  id: number;
  comment: string;
  read: boolean;
  answered: boolean;
  createdAt: string | Date;
  updatedAt: string | Date;
  user: {
    id: number;
    name: string;
    lastname: string;
    userType: string;
  };
}

export interface ContractDocument {
  id: number;
  contractId: number;
  pdfUrl: string | null;
  status: string;
  contractType: string;
  comment: string | null;
  deleted: boolean;
  createdAt: string | Date;
  updatedAt: string | Date;
}

export interface ContractTuitionPayment {
  id: number;
  type: string;
  status: string;
  amount: number;
  payedAt: string | Date | null;
}

export interface StudentContract {
  id: number;
  startDate: string | Date;
  endDate: string | Date;
  tuition: number;
  tuitionDiscount: number;
  tuitionAgreement: string | null;
  tuitionPaymentType?: string | null;
  feeDiscount?: number;
  feeDiscountType?: string | null;
  feeAdditionalDiscount?: number;
  feePaymentType?: string | null;
  feePaymentTypeDiscount?: number;
  feeDiscountInvalidPaymentMethods?: string | null;
  feeDiscountValidDays?: number | null;
  status?: string;
  statusName?: string;
  /** Fecha del último envío del plan de estudios al apoderado. */
  proposalSentAt?: string | Date | null;
  /** Fecha en que el apoderado aceptó el plan de estudios. */
  proposalAcceptedAt?: string | Date | null;
  comment?: string | null;
  installments?: Installment[];
  studentPrograms?: StudentProgram[];
  contractComments?: ContractComment[];
  contractDocuments?: ContractDocument[];
  /** Solo pagos de matrícula; el endpoint filtra el resto. */
  contractPayments?: ContractTuitionPayment[];
  academicYear: number;
  createdAt?: string | Date;
}

export interface Test {
  id: number;
  name: string;
}

export interface StudentRelevantInfo {
  testsToTake: Test[];
  testsComment: string;
  locationName: string;
  inscriptionYear: number;
  classYear: string;
  schoolName: string;
  relationToStudent?: string;
  leadName?: string;
  ambassadorCode?: string;
}

/** Valor base de matrícula (CLP) al crear o ver un plan de estudios sin monto guardado. */
export const DEFAULT_STUDY_PLAN_TUITION = 190_000;

export interface DiscountsProps {
  contract?: StudentContract;
  studentId: string;
  onContractUpdated?: () => void;
  /** Si es true, no se muestra el botón "Pagar Matrícula" (ya inscrito/pagado). */
  isEnrolled?: boolean;
  hasPendingTuitionPaymentDocument?: boolean;
}
